import styles from '../../Styles/index.module.scss'
import { generateJobScheduleSummary, PluginSchedule } from './lib/PluginSchedule'

interface ScheduleBlockSummaryProps {
    schedule: PluginSchedule
    isRuleActive?: boolean
}

export const ScheduleBlockSummary = (props: ScheduleBlockSummaryProps) => {
    const { schedule, isRuleActive } = props

    const summary = generateJobScheduleSummary(schedule, isRuleActive)

    return <div className={styles.summary}>{summary}</div>
}
